













import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ComparisonButton extends Vue {
  @Prop() private title!: string;
  @Prop() private imageClass!: string;
  @Prop() private linkTo!: string;
  @Prop() private linkParams?: any;
  @Prop({ default: "48px" }) private height?: string;

  private styleClasses = `${this.imageClass} icon`;
  private style = `height: ${this.height};`;

  private navigate() {
    this.$router.push({
      name: this.linkTo,
      query: { payload: JSON.stringify(this.linkParams) }
    });
  }
}
